

import * as React from "react";

var icon = require("./microbial-genomics.png");

var tools = /* array */[
  {
    term: /* QIIME2 */463720457,
    description: "Powerful, extensible, and decentralized end-to-end microbiome analysis package with a focus on data, visualization and analysis transparency."
  },
  {
    term: /* Mothur */-967341,
    description: "Open-source, platform-Independent, community supported software for describing and comparing microbial communities."
  },
  {
    term: /* MetaPhlAn2 */-504356778,
    description: "Tool for profiling the composition of microbial communities from metagenomic shotgun sequencing data based on clade-specific marker genes."
  },
  {
    term: /* HUMAnN2 */797202193,
    description: "The HMP Unified Metabolic Analysis Network is a method for efficiently and accurately determining the presence, absence, and abundance of metabolic pathways in a microbial community from metagenomic or metatranscriptomic sequencing data."
  },
  {
    term: /* Centrifuge */-978741780,
    description: "Very rapid and memory-efficient system for the classification of DNA sequences from microbial samples."
  },
  {
    term: /* Kraken2 */-463599144,
    description: "System for assigning taxonomic labels to short DNA sequences from metagenomic sequencing data."
  },
  {
    term: /* Kaiju */-277136002,
    description: "Fast taxonomic classification based on sequence comparison to a reference database of microbial proteins."
  },
  {
    term: /* MEGAN */61635740,
    description: "Comprehensive toolbox for analyzing large-scale microbiome sequencing data."
  },
  {
    term: /* CLARK */-968446159,
    description: "Supervised taxonomic classification of metagenomics reads using discriminative k-mers."
  },
  {
    term: /* GOTTCHA */872885588,
    description: "Gene-independent and signature-based metagenomic taxonomic profiling method."
  },
  {
    term: /* Sourmash */-957409406,
    description: "k-mer based taxonomic exploration and classification routines for genome and metagenome analysis."
  },
  {
    term: /* Taxonomer */-490342859,
    description: "k-mer based ultrafast metagenomics tool for assigning taxonomy to sequencing reads from both clinical and environmental samples."
  },
  {
    term: /* DIAMOND */-605144268,
    description: "Alignment tool for aligning short DNA sequencing reads to a protein reference database."
  },
  {
    term: /* MOCAT2 */-224558114,
    description: "Package for analyzing metagenomic datasets - generate taxonomic and functional profiles, assemble reads into scaftigs and predict genes in assembled sequences."
  },
  {
    term: /* MetaSPAdes */655533043,
    description: "Versatile metagenomic assembler."
  },
  {
    term: /* MetaVelvet */235453677,
    description: "Metagenomic assembly tool for mixed short reads of multiple species."
  },
  {
    term: /* RayMeta */-114511441,
    description: "Tools for scalable de novo metagenome assembly and profiling based on uniquely-colored k-mers."
  },
  {
    term: /* MEGAHIT */624266753,
    description: "Single node assembler for NGS data from large and complex metagenomics samples, such as soil."
  },
  {
    term: /* MaxBin */-220391261,
    description: "Software for binning assembled metagenomic sequences based on an Expectation-Maximization algorithm."
  },
  {
    term: /* CONCOCT */236342655,
    description: "Algorithm that combines sequence composition and coverage across multiple samples, to automatically cluster contigs into genomes."
  },
  {
    term: /* MetaBAT */-288656400,
    description: "Efficient tool for accurately reconstructing single genomes from complex microbial communities."
  },
  {
    term: /* VizBin */681208128,
    description: "Reference-independent visualization and human-augmented binning of metagenomic data."
  }
];

var fileTypes = /* array */[
  /* Csv */3357606,
  /* Tsv */4202999,
  /* Sam */4149247,
  /* Bam */3303854,
  /* Cram */748691835,
  /* Fasta */243398181,
  /* Fastq */243398197,
  /* Bed */3304737,
  /* Wig */4349941,
  /* BigBed */484974721,
  /* BigWig */486019925,
  /* BedGraph */-809444755,
  /* Gtf */3556729,
  /* Gff3 */792454412,
  /* Biom */737157829
];

var visualAnalytics = /* array */[
  {
    icon: /* BarChart */-298608085,
    description: "Graphs depicting relative abundance of taxa or OTUs in each sample for various levels of taxonomic hierarchy."
  },
  {
    icon: /* DonutChart */-642279940,
    description: "Pie diagram depicting relative abundance of taxa or OTUs in each sample for various levels of taxonomic hierarchy."
  },
  {
    icon: /* BubbleChart */118811026,
    description: "Size of bubble depicts relative abundance of taxa or OTUs in each sample for various levels of taxonomic hierarchy."
  },
  {
    icon: /* SankeyDiagram */758139700,
    description: "Flow diagrams depicting relative abundance of taxa or OTUs in each sample at various levels of taxonomic hierarchy."
  },
  {
    icon: /* Heatmap */988997452,
    description: "Color-coded matrices of community similarity that can be reordered to reveal patterns among samples."
  },
  {
    icon: /* Dendrogram */-508885141,
    description: "Tree-like diagrams clustering samples by community similarity."
  },
  {
    icon: /* PrincipalCoordinates */-496309491,
    description: "2-D and 3-D graphical representations of the relative similarity of samples and metadata."
  },
  {
    icon: /* KronaChart */300511203,
    description: "Hierarchical pie diagrams that provide intuitive exploration of relative abundances and confidences within the complex hierarchies of metagenomic classifications."
  },
  {
    icon: /* PhylogeneticTree */799219443,
    description: "Evolutionary relationships of taxa or OTUs overlaid with relative abundance and sample metadata."
  },
  {
    icon: /* PathwayMap */316537906,
    description: "Maps of biochemical capability of bacterial taxa."
  },
  {
    icon: /* NetworkDiagram */-449223643,
    description: "Understand microbiome-microbiome and microbiome-environment interactions."
  }
];

var description = React.createElement("p", undefined, "The development of NGS technologies for assaying microbial genetic material\n    in an environment has become a powerful new approach for rapidly\n    characterizing microbial communities, given a significant percentage of the\n    microbes are uncultivable.");

var overview = React.createElement(React.Fragment, undefined, React.createElement("p", undefined, "These experimental approaches along with novel computational methods,\n        are enabling us to understand the role of microbial shifts in human\n        health and disease, track and monitor contamination of food sources,\n        understand disease susceptibility in plants of agricultural importance,\n        rapidly respond to infectious disease outbreaks, characterize diversity,\n        biogeographic variability for environmental impact assessment and\n        ecological remediation, etc. The Human Microbiome Project and the Earth\n        Microbiome Project have only attested to the growing importance and\n        relevance of microbiome research."), React.createElement("p", undefined, "We support data analytics for (i) Meta-taxonomic approaches that profile\n        a community by amplicon sequencing of marker genes (16S rRNA, 18S rRNA,\n        ITS etc), (ii) Direct metagenomic taxonomic classification approaches\n        for quantitative community profiling and identification of organisms\n        with close relatives in the database, (iii) Characterization of\n        uncultivated microbes towards a more qualitative understanding of\n        metabolic capability through assembly and binning of the reads followed\n        by analysis of the binned draft genomes to obtain a comprehensive\n        catalog of genes and functions in all organisms, (iv) Profiling RNAs\n        from a complex microbial environment through meta-transcriptomics, etc."), React.createElement("p", undefined, "Whether you are working on a pipeline of therapeutics for various\n        disease indications, characterizing a microbial collection for seed\n        treatment or novel products to kill insects or fungal pathogens, or\n        improving pathogen detection and traceback for infectious disease\n        surveillance, we can help translate your microbiome research into\n        practical applications."), React.createElement("p", undefined, "Our integrated data solutions lets you manage and explore your processed\n        data derived from analytical pipelines. Simply upload your BIOM file\n        with taxonomic profiles from 16S or metagenome analysis tools and\n        pipelines, search over your BIOM files, explore and visualize the data."));

var id = "microbial-genomics";

var title = "Microbial Genomics";

export {
  id ,
  title ,
  icon ,
  overview ,
  description ,
  tools ,
  fileTypes ,
  visualAnalytics ,
  
}
/* icon Not a pure module */
